import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableClinicalProductFormFragment = { readonly __typename?: 'SyncableClinicalProductForm', readonly id: string, readonly keywords: ReadonlyArray<string>, readonly snomedId?: string | null, readonly title: { readonly __typename?: 'ClinicalProductFormTitle', readonly en: string, readonly es?: string | null, readonly fr?: string | null }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncClinicalProductFormPullQueryVariables = Types.Exact<{
  input: Types.PullClinicalProductFormInput;
}>;


export type SyncClinicalProductFormPullQuery = { readonly __typename?: 'Query', readonly pullClinicalProductForm: { readonly __typename?: 'PullClinicalProductFormResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableClinicalProductForm', readonly id: string, readonly keywords: ReadonlyArray<string>, readonly snomedId?: string | null, readonly title: { readonly __typename?: 'ClinicalProductFormTitle', readonly en: string, readonly es?: string | null, readonly fr?: string | null }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableClinicalProductFormFragmentDoc = gql`
    fragment WholeSyncableClinicalProductForm on SyncableClinicalProductForm {
  id
  title {
    en
    es
    fr
  }
  keywords
  snomedId
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncClinicalProductFormPullDocument = gql`
    query SyncClinicalProductFormPull($input: PullClinicalProductFormInput!) {
  pullClinicalProductForm(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableClinicalProductForm
    }
  }
}
    ${WholeSyncableClinicalProductFormFragmentDoc}`;

/**
 * __useSyncClinicalProductFormPullQuery__
 *
 * To run a query within a React component, call `useSyncClinicalProductFormPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncClinicalProductFormPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncClinicalProductFormPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncClinicalProductFormPullQuery(baseOptions: Apollo.QueryHookOptions<SyncClinicalProductFormPullQuery, SyncClinicalProductFormPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncClinicalProductFormPullQuery, SyncClinicalProductFormPullQueryVariables>(SyncClinicalProductFormPullDocument, options);
      }
export function useSyncClinicalProductFormPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncClinicalProductFormPullQuery, SyncClinicalProductFormPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncClinicalProductFormPullQuery, SyncClinicalProductFormPullQueryVariables>(SyncClinicalProductFormPullDocument, options);
        }
export type SyncClinicalProductFormPullQueryHookResult = ReturnType<typeof useSyncClinicalProductFormPullQuery>;
export type SyncClinicalProductFormPullLazyQueryHookResult = ReturnType<typeof useSyncClinicalProductFormPullLazyQuery>;
export type SyncClinicalProductFormPullQueryResult = Apollo.QueryResult<SyncClinicalProductFormPullQuery, SyncClinicalProductFormPullQueryVariables>;